// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"xp-z","imageAndVideoCount":"yp-z","imageAndVideoContainer":"zp-z","viewAllReviews":"Ap-z"};